import { IData } from 'shared/types/dataType'
import { ILibrary } from 'components/templates/LibraryTemplate'

export const library = ({ language }: IData): ILibrary =>
  ({
    fr: {
      header: {
        banner: {
          title: 'Médiathèque',
          image: {
            alt: 'actualites',
            urlMobile: '/assets/images/media/library/library-banner-mobile.png',
            urlDesktop: '/assets/images/media/library/library-banner-desktop.png'
          }
        }
      }
    },
    en: {
      header: {
        banner: {
          title: 'Médiathèque',
          image: {
            alt: 'actualites',
            urlMobile: '/assets/images/media/library/library-banner-uk-mobile.png',
            urlDesktop: '/assets/images/media/library/library-banner-uk-desktop.png'
          }
        }
      }
    }
  }[language])
